// extracted by mini-css-extract-plugin
export default {"root":"_7h2XSgX0"};